import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventsApi } from '../api/events';
import { getErrorMessage } from '../api/client';
import Button from '../components/ui/Button';
import Spinner from '../components/ui/Spinner';
import Alert from '../components/ui/Alert';
import EventCard from '../components/EventCard';
import { IconParty } from '../components/ui/Icons';

export default function Dashboard() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await eventsApi.list();
      setEvents(data);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este evento?')) return;
    try {
      await eventsApi.remove(id);
      setEvents((prev) => prev.filter((e) => e.id !== id));
    } catch (err) {
      alert(getErrorMessage(err));
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold">Mis eventos</h1>
          <p className="text-sm text-slate-500">
            {events.length} evento{events.length !== 1 && 's'}
          </p>
        </div>
        <Link to="/templates">
          <Button>+ Crear evento</Button>
        </Link>
      </div>

      {error && <Alert type="error">{error}</Alert>}

      {loading ? (
        <div className="grid place-items-center py-20">
          <Spinner size="lg" className="text-brand-500" />
        </div>
      ) : events.length === 0 ? (
        <div className="bg-white border border-dashed border-slate-300 rounded-2xl p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-4 text-brand-500 opacity-60">
  <IconParty className="w-full h-full" />
</div>
          <h2 className="font-bold text-lg mb-1">Aún no tienes eventos</h2>
          <p className="text-sm text-slate-500 mb-6">
            Elige una plantilla y crea tu primera invitación digital.
          </p>
          <Link to="/templates">
            <Button>Ver plantillas</Button>
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {events.map((ev) => (
            <EventCard
              key={ev.id}
              event={ev}
              onDelete={() => handleDelete(ev.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}